/*
 * Carlyle Avenue PDP trust strip — preorder-aware shipping row.
 * ---------------------------------------------------------------------------
 * Row 1 of the trust grid promises a ship time ("Ships in 1 to 2 days"), which
 * is false for a preorder variant. The block renders the correct row server-side;
 * this keeps it in sync when the shopper switches variants (in-stock scent ↔
 * preorder scent) by copying the authoritative, freshly server-rendered row out
 * of the variant:update payload — the same technique as ca-stock.js. Only loaded
 * when preorders are enabled.
 *
 * Vanilla JS, no dependencies. IIFE + page-level init guard.
 */
(function () {
  if (window.__caTrustInit) return;
  window.__caTrustInit = true;

  document.addEventListener('variant:update', function (event) {
    var detail = event.detail || {};
    if (!detail.resource) return;

    var newDoc = detail.data && detail.data.html;
    var newRow = newDoc && newDoc.querySelector ? newDoc.querySelector('[data-ca-trust-ship]') : null;
    if (!newRow) return;

    var scope = (event.target.closest && event.target.closest('.shopify-section')) || document;
    var rows = scope.querySelectorAll('[data-ca-trust-ship]');
    var newHeading = newRow.querySelector('[data-ca-trust-ship-heading]');
    var newText = newRow.querySelector('[data-ca-trust-ship-text]');

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var heading = row.querySelector('[data-ca-trust-ship-heading]');
      var text = row.querySelector('[data-ca-trust-ship-text]');
      if (heading && newHeading) heading.textContent = newHeading.textContent;
      if (text && newText) text.textContent = newText.textContent;
    }
  });
})();
